module.exports = __webpack_public_path__ + "img/bank.877fcf09.svg";